import React, { forwardRef, useContext } from 'react';
//add js doc to accept isLoggedin prop as boolean
import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  useDisclosure
} from '@chakra-ui/react';
import Icon from 'components/atoms/Icon/Icon';
import AuthContext from 'context/AuthProvider';
import { navigate } from 'gatsby';
import useHoverOutside from 'hooks/useHoverOutside';
import { bcLoginUrl } from 'helpers/bigcommerce';
import { get } from 'lodash';
// import useABTest from 'hooks/useABTest';

const routes = [
  {
    label: 'My Account',
    url: '/account/'
  },
  {
    label: 'My Prescriptions',
    url: '/account/prescriptions'
  },
  {
    label: 'Orders',
    url: '/account/orders'
  },
  {
    label: 'Wishlists',
    url: '/account/wishlists'
  },
  {
    label: 'Addresses',
    url: '/account/addresses'
  },
  {
    label: 'Payments',
    url: '/account.php?action=payment_methods',
    external: true
  },
  {
    label: 'Autoship',
    url: '/subscriptions',
    external: true
  },
  {
    label: 'Log out',
    url: '/logout',
    divider: true
  }
];

const HeaderMenu = forwardRef((_, ref) => {
  const { isOpen, onToggle, onClose } = useDisclosure();

  const auth = useContext(AuthContext);

  const { customerId } = get(auth, 'state', {});
  const handleLogout = auth && auth.logout;
  const enableMyPrescriptions = process.env.GATSBY_PRESCRIPTION === 'true';
  useHoverOutside([ref], () => {
    onClose();
  });

  const navigateHandler = url => {
    if (url === '/logout') {
      navigate('/');
      handleLogout();
    } else {
      onClose();
      navigate(url);
    }
  };

  const redirectHandler = url => {
    bcLoginUrl(customerId, url).then(url => {
      // console.log("Logged in", url);
      onClose();
      window.location = url;
    });
  };

  return (
    <Menu isOpen={isOpen}>
      <MenuButton
        w={'45px'}
        tabIndex={0}
        h={'45px'}
        flexShrink={0}
        rounded={'full'}
        as={IconButton}
        onClick={onToggle}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            onToggle();
          }
        }}
        variant={'ghost'}
        icon={
          <Avatar
            sx={{
              '>div': {
                fontSize: '16px'
              }
            }}
            size="sm"
            rounded={'full'}
            color={'#14617A'}
            border={'2px solid #14617A'}
            m={0}
            name={auth?.state?.object?.first_name}
            bg={'none'}
            p={0}
          />
        }
      ></MenuButton>
      <MenuList
        zIndex={100}
        p={0}
        border={'none'}
        boxShadow={'0px 0px 15px 0px rgba(3, 80, 105, 0.13)'}
      >
        <MenuGroup title={`Hi, ${auth?.state?.object?.first_name}  👋`} p={6} m={0} fontSize={16}>
          <Box h="1px" bg={'#C9D5DA9C'} mx={6} mb={0}></Box>
          {routes.map((route, index) => {
            if (route.url === '/account/prescriptions' && !enableMyPrescriptions) return null;
            return (
              <React.Fragment key={index}>
                {route.divider && <Box h="1px" bg={'#C9D5DA9C'} mx={6} mb={0}></Box>}
                <MenuItem
                  mt={index === 0 ? 3 : 0}
                  mb={index === routes.length - 2 ? 3 : 0}
                  py={index === routes.length - 1 ? 6 : 3}
                  px={6}
                  _hover={{ bg: 'var(--grey-04);' }}
                  key={index}
                  zIndex={0}
                  onClick={
                    route.external
                      ? () => redirectHandler(route.url)
                      : () => navigateHandler(route.url)
                  }
                  justifyContent={'space-between'}
                >
                  {route.label}
                  <Icon symbol={'chevRight'} />
                </MenuItem>
              </React.Fragment>
            );
          })}
        </MenuGroup>
      </MenuList>
    </Menu>
  );
});

export default HeaderMenu;
